<template>
    <div id="app">
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"/>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"/>
    </div>
</template>

<script>
    import {
        mapMutations,
        mapActions,
        mapState
    } from 'vuex';
    import platform from "./utils/platform";

    export default {
        name: 'App',
        data() {
            return {}
        },
        beforeCreate() {
            let isMobile = platform.isMobile()
            if(isMobile){
                window.location.href = 'https://xiangjunkeji.cn/mobile'
            }
        },
        computed: {
            monitor() {
                return this.$store.store.state.userData;
            }
        },
        destroyed() {
            window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))
            window.removeEventListener('unload', e => this.unloadHandler(e))
        },
        watch: {
            monitor(val) {
                // console.log(val, "sdkkkkkkkk")
            }
        },
        methods: {
            beforeunloadHandler() {
                this._beforeUnload_time = new Date().getTime();

            },
            unloadHandler(e) {
                this._gap_time = new Date().getTime() - this._beforeUnload_time;
                //判断是窗口关闭还是刷新
                if (this._gap_time <= 5) {
                    localStorage.removeItem('user_token');
                    localStorage.removeItem('user_data');
                    localStorage.removeItem('login');
                    localStorage.removeItem('lastTime');
                }
            },
        },
        created() {
            let _this = this;

            let _beforeUnload_time = 0, _gap_time = 0;

            localStorage.getItem("userMsg") && _this.$store.store.replaceState(Object.assign(_this.$store.store.state, JSON
                .parse(
                    localStorage.getItem("userMsg"))));
            _this.$global.token = _this.$store.store.state.userToken;
            _this.$global.webData = _this.$store.store.state.userData;

            window.addEventListener("beforeunload", (e) => {
                console.log(JSON.stringify(_this.$store.store.state));
                localStorage.setItem("userMsg", JSON.stringify(_this.$store.store.state));
            })

            window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
            window.addEventListener('unload', e => this.unloadHandler(e))


            _this.$store.store.dispatch('getTemplate');
            if (_this.$global.token && localStorage.getItem('login')) {
                let formdata = new FormData();
                formdata.append('token', _this.$global.token);
                _this.$store.store.dispatch('getUserInfo', formdata);
            }

        }

    }
</script>

<style>
    #app {
    }

    a {
        text-decoration: none;
    }

    body {
        margin: 0;
        padding-right: 0 !important;
        overflow-x: hidden;
    }

    .el-popup-parent--hidden {
        overflow: visible !important;
    }

    .my-el-custom-spinner {
        background: url("../static/img/loading.gif");
        background-size: 100px 100px;
        width: 100px;
        height: 100px;
        display: inline-block;
    }

    .el-loading-text {
        font-size: 24px !important;
        margin-top: 20px !important;
    }


    div {
        box-sizing: border-box;
    }


    body::-webkit-scrollbar {
        width: 0px;
    }

    body::-webkit-scrollbar-track {
        --webkit-box-shadow: inset 0 0 0px rgba(0, 0, 0, 0.3);
        border-radius: 10px;
    }

    body::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background: #fff0;
        --webkit-box-shadow: inset 0 0 0px rgba(0, 0, 0, 0.1);
    }

    body::-webkit-scrollbar-thumb:window-inactive {
        background: #fff0;

    }
</style>



// WEBPACK FOOTER //
// src/App.vue